export default __webpack_public_path__ + "static/img2-cf6912e63e5110c7caf0c3d3ad1968d3.webp";